import styled from 'styled-components';
import tu from '../utils/themeUtils';
import Box from './Box';

const Panel = styled(Box)`
  background-color: ${tu.color('bg2')};
`;

export default Panel;
